import { render, staticRenderFns } from "./RecentlyOpened.vue?vue&type=template&id=0e8823a2&scoped=true&"
import script from "./RecentlyOpened.vue?vue&type=script&lang=js&"
export * from "./RecentlyOpened.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyOpened.vue?vue&type=style&index=0&id=0e8823a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8823a2",
  null
  
)

export default component.exports